import { render } from "./Gameboard_SidePanel_Marketing.vue?vue&type=template&id=118b00b5"
import script from "./Gameboard_SidePanel_Marketing.vue?vue&type=script&lang=js"
export * from "./Gameboard_SidePanel_Marketing.vue?vue&type=script&lang=js"

import "./Gameboard_SidePanel_Marketing.vue?vue&type=style&index=0&id=118b00b5&lang=scss"
script.render = render

export default script